import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "inquiry-left-div",
  style: {"float":"left"}
}
const _hoisted_2 = { id: "tblInquiryLeft" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Help Page Links")
], -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", { class: "inq-a-link" }, "Contact Information", -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", { class: "inq-a-link" }, "Manual List", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", { class: "inq-a-link" }, "New User Invitation", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createVNode(_component_router_link, { to: "/InquiryInfo" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1 /* STABLE */
          })
        ])
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createVNode(_component_router_link, { to: "/ManualInfo" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1 /* STABLE */
          })
        ])
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createVNode(_component_router_link, { to: "/invite" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1 /* STABLE */
          })
        ])
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createElementVNode("a", {
            class: "calendar-link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openCalendarPDF()))
          }, " SMC Calendar ")
        ])
      ])
    ])
  ]))
}